var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgListIcon = function SvgListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: currentColor;\n      }"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.63,23.44c-.15,0-.29-.02-.41-.07-.13-.05-.25-.13-.37-.25l-5.96-5.96c-.22-.22-.32-.49-.32-.81,0-.32,.11-.59,.33-.81,.22-.22,.48-.32,.78-.32s.57,.11,.78,.32l5.17,5.17,11.89-11.89c.22-.22,.48-.32,.8-.32s.58,.11,.8,.32c.22,.22,.32,.48,.32,.8s-.11,.58-.32,.8l-12.7,12.7c-.12,.12-.24,.2-.37,.25-.13,.05-.26,.07-.41,.07Z"
  })));
};
export default SvgListIcon;